import React, { useEffect, useRef, useState } from 'react';
import '../styles/Intro.css';
import introImage from '../Assets/Images/Akij-Insaf-logo.png';
import values from '../Assets/Images/value.jpg';

function Intro() {
  const imgRef = useRef(null);
  const [punch, setPunch] = useState(false);
  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setPunch(true);
          setTimeout(() => setPunch(false), 1000);
        }
      },
      { threshold: 0.5 }
    );

    if (imgRef.current) observer.observe(imgRef.current);
    return () => {
      if (imgRef.current) observer.unobserve(imgRef.current);
    };
  }, []);

  const fullText = (
    <>
      <h2>ABOUT AKIJ INSAF</h2>
      <p>
        Akij INSAF (formerly known as Akij Group) is one of the leading names in the industrial sector of Bangladesh.
        Its current operations were initiated in 2020 under the leadership of Sk. Jamil Uddin. The company manages
        its extensive business activities through a workforce of over 15,000 employees across various levels.
      </p>
      <br />
      <p>
        Akij INSAF has sincerely fostered a safe working environment, and dignified profession for all employees of the
        organization through practicing integrity, naturing ability, sincerity, positive attitude, and fairness. Its
        diverse range of industrial products has gained significant recognition and trust from customers nationwide.
      </p>
      <br />
      <p>
        The company is renowned for its diversified business portfolio, which includes Bakery, Flour, Textile, Printing
        & Packaging, and Lifestyle products. In addition to contributing significantly to the growth of Bangladesh's
        industrial economy and generating substantial employment, Akij INSAF also plays an active role in fulfilling
        its social responsibilities. This includes support for hospitals, schools, madrasas, and technical institutes,
        with a commitment to building a prosperous and self-reliant nation.
      </p>
    </>
  );

  return (
    <section className="intro-section" id="about">
      <h2>ABOUT AKIJ INSAF</h2>
      <div className="intro-container">
        <div className="intro-text">
          <p>
            Akij INSAF (formerly known as Akij Group) is one of the leading names in the industrial sector of Bangladesh.
            Its current operations were initiated in 2020 under the leadership of Sk. Jamil Uddin. The company manages
            its extensive business activities through a workforce of over 15,000 employees across various levels.
          </p>
          
          <div className="show-more-container">
            <button className="show-more-btn" onClick={() => setShowModal(true)}>
              ...show more
            </button>
          </div>
        </div>

        <div className="intro-image">
          <img
            ref={imgRef}
            src={introImage}
            alt="About Akij Insaf Group"
            className={punch ? 'punch-effect' : ''}
          />
        </div>

        <div className="intro-image2">
          <img ref={imgRef} src={values} alt="Akij Values" />
        </div>
      </div>

      {/* Modal */}
      {showModal && (
        <div className="modal-overlay" onClick={() => setShowModal(false)}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <button className="modal-close" onClick={() => setShowModal(false)}>
              &times;
            </button>
            <div className="modal-text">{fullText}</div>
          </div>
        </div>
      )}
    </section>
  );
}

export default Intro;
